import formatDate from './formatDate';

const formatDateTime = (date: Date): string => {
    return `${formatDate(date)} ${
        date.toISOString().split('T')[1].split('.')[0]
    }`;
};

export default formatDateTime;
